/**
 * Local demo assistant copy (Markdown) for UI testing when APIs are unavailable.
 * @param {string} userText
 */
export function buildDemoAssistantMarkdown(userText) {
  const excerpt = (userText || '').trim();
  const shown = excerpt.length > 220 ? `${excerpt.slice(0, 220)}…` : excerpt;
  const safe = shown.replace(/`/g, "'");

  return [
    '## Demo assistant',
    '',
    'This is a **local demo response** while `REACT_APP_AI_CHAT_DEMO_RESPONSES=true` (no conversation API).',
    '',
    '### Your message',
    '',
    safe ? `> ${safe}` : '_(empty message)_',
    '',
    '### Sample content (try **Copy** / **Copy MD**)',
    '',
    '1. First item',
    '2. Second item',
    '',
    '- Bullet A',
    '- Bullet B',
    '',
    '```json',
    '{ "demo": true, "source": "ddv-client" }',
    '```',
    '',
    '_End of demo reply._',
  ].join('\n');
}

/**
 * @param {(chunk: string) => void} onDelta
 * @param {string} fullText
 * @param {{ chunkMs?: number, charsPerChunk?: number }} [opts]
 */
export async function streamDemoAssistantContent(onDelta, fullText, opts = {}) {
  const chunkMs = opts.chunkMs ?? 35;
  const charsPerChunk = opts.charsPerChunk ?? 6;
  const text = fullText || '';
  for (let i = 0; i < text.length; i += charsPerChunk) {
    onDelta(text.slice(i, i + charsPerChunk));
    /* eslint-disable no-await-in-loop */
    await new Promise((r) => {
      setTimeout(r, chunkMs);
    });
  }
}
